import React from 'react';
import cs from 'classnames';
import { Icon } from '../../atoms/Icon';
export var Button = function Button(props) {
  var _props$kind = props.kind,
      kind = _props$kind === void 0 ? 'primary' : _props$kind,
      label = props.label,
      href = props.href,
      onClick = props.onClick,
      icon = props.icon,
      ariaLabel = props.ariaLabel,
      iconRight = props.iconRight,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      _props$size = props.size,
      size = _props$size === void 0 ? 'default' : _props$size,
      target = props.target,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      className = props.className;
  var Tag = href ? 'a' : 'button';

  var handleClick = function handleClick(e) {
    if (href && onClick) {
      e.preventDefault();
    }

    if (onClick) {
      onClick(e);
    }
  };

  return /*#__PURE__*/React.createElement(Tag, {
    className: cs('telia-business-button', "telia-business-button--".concat(kind), "telia-business-button--".concat(size), {
      'telia-business-button--iconRight': iconRight,
      'telia-business-button--iconLeft': icon && !iconRight,
      'telia-business-button--ball': icon && !label,
      'telia-business-button--disabled': disabled,
      'telia-business-button--active': active
    }, className),
    href: href,
    onClick: handleClick,
    disabled: disabled,
    type: href ? undefined : type,
    target: href ? target : undefined,
    "aria-label": ariaLabel
  }, icon && /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    className: "telia-business-button__icon"
  }), label);
};